const fuelTypeElectricOrPluginHybrid = (fuelTypeDescription) => {
    if (!fuelTypeDescription){
        return false;
    }
    try{
        let data = null;

        switch (fuelTypeDescription) {
            case "Petrol":
            case "Diesel":
            case "Petrol/LPG":
            case "Petrol/CNG":
            case "Petrol/Bio Ethanol (E85)":
            case "Hydrogen Fuel Cell":
                data = false;
                break;
            case "Electric":
            case "Petrol/Electric Hybrid":
            case "Diesel/Electric Hybrid":
            case "Hybrid Petrol / Electric":
            case "Hybrid Diesel / Electric":
            case "Petrol/Plug-In Electric":
            case "Diesel/Plug-In Electric":
            case "Electric Range Extended":
                data  = true;
                break;
            default:
                data  = false;
        }

        return data;
    }catch(e){
        return false;
    }
}

const fuelTypeElectric = (fuelTypeDescription) => {
    if (!fuelTypeDescription){
        return false;
    }
    try{
        let data = null;

        switch (fuelTypeDescription) {
            case "Petrol":
            case "Diesel":
            case "Petrol/LPG":
            case "Petrol/CNG":
            case "Petrol/Bio Ethanol (E85)":
            case "Hydrogen Fuel Cell":
                data = false;
                break;
            case "Electric":
            case "Petrol/Electric Hybrid":
            case "Diesel/Electric Hybrid":
            case "Hybrid Petrol / Electric":
            case "Hybrid Diesel / Electric":
            case "Petrol/Plug-In Electric":
            case "Diesel/Plug-In Electric":
            case "Electric Range Extended":
                data  = true;
                break;
            default:
                data  = false;

        }

        return data;
    }catch(e){
        return false;
    }
}


export {
    fuelTypeElectricOrPluginHybrid,
    fuelTypeElectric
};
